// Login as a full page at /login (no modal)
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFileContext } from '../../ContextAPI/FileContext';
import LoginModal from './LoginModal';
import './LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { auth } = useFileContext();

  // If already authenticated, go to app
  useEffect(() => {
    if (auth) {
      navigate('/projects', { replace: true });
    }
  }, [auth, navigate]);

  const handleSuccess = () => {
    navigate('/projects', { replace: true });
  };

  const handleClose = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="login-page">
      <LoginModal
        asPage
        open={true}
        handleClose={handleClose}
        onSuccess={handleSuccess}
        onClose={handleClose}
      />
    </div>
  );
};

export default LoginPage;
